// extracted by mini-css-extract-plugin
export default {"menuBlock":"ZD-z","title":"_D-z","nav":"aE-z","flexCell":"bE-z","facetLink":"cE-z"};